/* Base translations · Review points and review forms — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): reviewPointsPage, reviewPoints, reviewForms, reviewSpec. */
export const I18N_BASE_REVIEW_POINTS = {
  en: {
    reviewPointsPage: {
      noEngagement: "Select an engagement from the top bar to see its review points.",
      title: "Review Points",
      subtitle: "All review points raised across this engagement's Planning, Risk, Completion forms and Vouching sheets.",
      refreshBtn: "Refresh",
      exportBtn: "Export",
      exportCsv: "CSV",
      exportXlsx: "Excel (.xlsx)",
      exportPdf: "PDF",
      summary: {
        total: "Total",
        pending: "Pending",
        in_progress: "In Progress",
        resolved: "Resolved",
        cleared: "Cleared",
        overdue: "Overdue",
      },
      targets: {
        planning_form: "Planning Form",
        risk_assessment_form: "Risk Assessment",
        completion_form: "Completion Form",
        vouching_sheet: "Vouching Sheet",
        vouching_entry: "Vouching Entry",
      },
      filterQPh: "Search review-point text…",
      statusPh: "Status",
      rolePh: "Raised by role",
      priorityPh: "Priority",
      targetPh: "Target",
      allStatuses: "All statuses",
      allRoles: "All roles",
      allPriorities: "All priorities",
      allTargets: "All targets",
      status: {
        Pending: "Pending",
        "In Progress": "In Progress",
        Resolved: "Resolved",
        Cleared: "Cleared",
      },
      priority: {
        Critical: "Critical",
        High: "High",
        Medium: "Medium",
        Low: "Low",
      },
      colReviewPoint: "Review point",
      colTarget: "Target",
      colReference: "Reference",
      colRaisedBy: "Raised by",
      colRole: "Role",
      colStatus: "Status",
      colPriority: "Priority",
      colRaised: "Raised",
      colCleared: "Cleared",
      colOpen: "Open",
      loading: "Loading…",
      noMatch: "No review points match this filter.",
      openLabel: "Open {label}",
      openFallback: "source",
      toastLoadFail: "Failed to load dashboard",
      toastExportFail: "Export failed",
      toastExportStatusFail: "Export failed ({status})",
      toastExported: "Exported {fname}",
    },
    reviewPoints: {
      panelTitle: "Review points",
      raiseAdd: "Review",
      raiseTip: "Raise a review point on this item",
      loading: "Loading…",
      empty: "No review points on this item yet.",
      newTitle: "Raise a new review point",
      newPlaceholder: "Describe the point that needs the preparer's attention…",
      priority: "Priority",
      dueOptional: "Due date (optional)",
      raise: "Raise review point",
      raising: "Raising…",
      raised: "Review point raised",
      enterText: "Enter the review point",
      failedRaise: "Failed to raise review point",
      failedLoad: "Failed to load review points",
      openSource: "Open source",
      openSourceLabel: "Open {label}",
      commentBtn: "Comment",
      historyBtn: "History",
      hideBtn: "Hide",
      deleteBtn: "Delete",
      resolveBtn: "Resolve",
      clearBtn: "Clear",
      reopenBtn: "Reopen",
      inProgressBtn: "In Progress",
      markedInProgress: "Marked In Progress",
      markedResolved: "Marked Resolved",
      cleared: "Cleared",
      reopened: "Reopened",
      priorityPrefix: "Priority: {p}",
      deletedTag: "deleted",
      raisedByLine: "Raised by {name} ({role}) · {date}",
      dueSuffix: " · due {date}",
      commentPh: "Add a comment…",
      postComment: "Post comment",
      commentAdded: "Comment added",
      commentFailed: "Comment failed",
      enterComment: "Enter a comment",
      loadHistoryFailed: "Load history failed",
      deleteConfirm: "Delete this review point? It will be soft-deleted (kept in history).",
      deleted: "Deleted",
      deleteFailed: "Delete failed",
      commentsLabel: "Comments",
      timelineLabel: "Timeline",
      attachmentsLabel: "Attachments",
      commentByLine: "({role} · {when})",
      badgeSummary: "{plural} — {open} open, {cleared} cleared",
    },
    reviewForms: {
      // F2 — review-wording variants for the shared acceptance forms.
      // Applied on Review engagements only; audit engagements unchanged.
      acceptanceNoticeEN: "Review engagement — the engagement letter and acceptance form below use limited-assurance wording (ISRE 2400 Revised). This is a review, not an audit.",
      acceptanceNoticeAR: "ارتباط فحص — تستخدم رسالة الارتباط ونموذج القبول أدناه صياغة التأكيد المحدود (\u2066ISRE 2400\u2069 المُنقّح). هذا فحص، وليس مراجعة.",
      elReviewTitleEN: "Engagement letter — review (limited assurance)",
      elReviewTitleAR: "رسالة الارتباط — فحص (تأكيد محدود)",
      elReviewBodyEN: "We will conduct our engagement to review the accompanying financial statements in accordance with ISRE 2400 (Revised). Our conclusion will express whether anything has come to our attention that causes us to believe that the financial statements are not prepared, in all material respects, in accordance with the applicable financial-reporting framework. A review differs significantly from an audit; we will not express an audit opinion.",
      elReviewBodyAR: "سنؤدي ارتباطنا لفحص القوائم المالية المرفقة وفقًا للمعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح). ستعبِّر خلاصتنا عمّا إذا كان قد ورد إلى علمنا ما يجعلنا نعتقد أن القوائم المالية لم تُعَدّ من جميع النواحي الجوهرية وفقًا لإطار التقرير المالي المطبَّق. يختلف الفحص اختلافًا جوهريًا عن المراجعة؛ ولن نُبدي رأيًا في المراجعة.",
      cacReviewTitleEN: "Client acceptance / continuance — review",
      cacReviewTitleAR: "قبول العميل / استمراره — فحص",
      cacReviewBodyEN: "This acceptance record captures the preconditions for a review engagement under ISRE 2400 (Revised): rational purpose, an acceptable financial-reporting framework, management's acknowledgement of its responsibilities, ethics and independence, availability of information and no management-imposed scope limitation. Wording used throughout is limited-assurance.",
      cacReviewBodyAR: "يوثِّق هذا السجل الشروط المسبقة لارتباط الفحص وفق \u2066ISRE 2400\u2069 (المُنقّح): الغرض المنطقي، وإطار التقرير المالي المقبول، وإقرار الإدارة بمسؤولياتها، والسلوك المهني والاستقلالية، وإتاحة المعلومات، وعدم وجود قيد على النطاق مفروض من الإدارة. الصياغة المستخدمة تعبِّر عن التأكيد المحدود.",
      // J1 — sub-title override for 106(a) / 100(a) on Review engagements.
      elSubtitleEN: "Based on ISRE 2400 (Revised) — Agreeing the terms of a review engagement",
      elSubtitleAR: "استنادًا إلى المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — الاتفاق على شروط ارتباط الفحص",
      cacSubtitleEN: "Based on ISRE 2400 (Revised) — Agreeing the terms of a review engagement",
      cacSubtitleAR: "استنادًا إلى المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — الاتفاق على شروط ارتباط الفحص",
      // J1(b) — greyed-section label + enable UI copy.
      sectionGreyEN: "Not used in a review — preconditions are in \u2066501(r)\u2069",
      sectionGreyAR: "غير مستخدم في ارتباط الفحص — الشروط المسبقة في \u2066501(r)\u2069",
      sectionEnableTitleEN: "Enable this section for this engagement",
      sectionEnableTitleAR: "تفعيل هذا القسم لهذه المهمة",
      sectionEnableHintEN: "Any engagement-team auditor may enable this section for a documented review matter (additional or alternative procedure). The change is logged.",
      sectionEnableHintAR: "يجوز لأي عضو من فريق المهمة تفعيل هذا القسم لموضوع فحص موثَّق (إجراء إضافي أو بديل). يُسجَّل التغيير.",
      sectionEnableBtnEN: "Enable this section",
      sectionEnableBtnAR: "تفعيل هذا القسم",
      sectionEnabledOkEN: "Section enabled for this engagement.",
      sectionEnabledOkAR: "تم تفعيل القسم لهذه المهمة.",
    },
    // K6 — spec labels used across W17.3–W17.7 (verbatim from Batch E
    // spec). Referenced as `reviewSpec.<key>` so both column labels
    // and section labels resolve identically in EN and AR.
    reviewSpec: {
      materialItem: "Material item",
      inquiry: "Inquiry",
      analyticalProcedure: "Analytical procedure",
      conclusion: "Conclusion",
      conclusionSatisfactory: "Satisfactory",
      conclusionFollowup: "Follow-up → W17.7",
      requiredInquiries: "Required inquiries",
      fraudOrNoncomplianceIndicators: "Fraud or non-compliance indicators",
      reconciliationToAccountingRecords: "Reconciliation to accounting records",
      additionalProcedures: "Additional procedures",
      outcome: "Outcome",
      areasLikelyMisstatement: "Areas where material misstatements are likely",
    },
  },
  ar: {
    reviewPointsPage: {
      noEngagement: "اختر مهمة من الشريط العلوي لرؤية نقاط المراجعة الخاصة بها.",
      title: "نقاط المراجعة",
      subtitle: "جميع نقاط المراجعة التي أُثيرت في نماذج التخطيط والمخاطر والإكمال وأوراق التحقق لهذه المهمة.",
      refreshBtn: "تحديث",
      exportBtn: "تصدير",
      exportCsv: "CSV",
      exportXlsx: "Excel (.xlsx)",
      exportPdf: "PDF",
      summary: {
        total: "الإجمالي",
        pending: "قيد الانتظار",
        in_progress: "قيد التنفيذ",
        resolved: "تم الحل",
        cleared: "تم الإغلاق",
        overdue: "متأخرة",
      },
      targets: {
        planning_form: "نموذج التخطيط",
        risk_assessment_form: "تقييم المخاطر",
        completion_form: "نموذج الإكمال",
        vouching_sheet: "ورقة التحقق",
        vouching_entry: "إدخال التحقق",
      },
      filterQPh: "ابحث في نص نقاط المراجعة…",
      statusPh: "الحالة",
      rolePh: "أُثيرت من قِبَل الدور",
      priorityPh: "الأولوية",
      targetPh: "الهدف",
      allStatuses: "كل الحالات",
      allRoles: "كل الأدوار",
      allPriorities: "كل الأولويات",
      allTargets: "كل الأهداف",
      status: {
        Pending: "قيد الانتظار",
        "In Progress": "قيد التنفيذ",
        Resolved: "تم الحل",
        Cleared: "تم الإغلاق",
      },
      priority: {
        Critical: "حرجة",
        High: "عالية",
        Medium: "متوسطة",
        Low: "منخفضة",
      },
      colReviewPoint: "نقطة المراجعة",
      colTarget: "الهدف",
      colReference: "المرجع",
      colRaisedBy: "أثارها",
      colRole: "الدور",
      colStatus: "الحالة",
      colPriority: "الأولوية",
      colRaised: "أُثيرت",
      colCleared: "أُغلقت",
      colOpen: "فتح",
      loading: "جاري التحميل…",
      noMatch: "لا توجد نقاط مراجعة مطابقة لهذا الفلتر.",
      openLabel: "فتح {label}",
      openFallback: "المصدر",
      toastLoadFail: "فشل تحميل لوحة التحكم",
      toastExportFail: "فشل التصدير",
      toastExportStatusFail: "فشل التصدير ({status})",
      toastExported: "تم تصدير {fname}",
    },
    reviewPoints: {
      panelTitle: "نقاط المراجعة",
      raiseAdd: "مراجعة",
      raiseTip: "أثر نقطة مراجعة على هذا البند",
      loading: "جاري التحميل…",
      empty: "لا توجد نقاط مراجعة على هذا البند بعد.",
      newTitle: "إثارة نقطة مراجعة جديدة",
      newPlaceholder: "صف النقطة التي تحتاج إلى انتباه المُعدّ…",
      priority: "الأولوية",
      dueOptional: "تاريخ الاستحقاق (اختياري)",
      raise: "إثارة نقطة المراجعة",
      raising: "جاري الإثارة…",
      raised: "تمت إثارة نقطة المراجعة",
      enterText: "أدخل نقطة المراجعة",
      failedRaise: "فشل إثارة نقطة المراجعة",
      failedLoad: "فشل تحميل نقاط المراجعة",
      openSource: "فتح المصدر",
      openSourceLabel: "فتح {label}",
      commentBtn: "تعليق",
      historyBtn: "السجل",
      hideBtn: "إخفاء",
      deleteBtn: "حذف",
      resolveBtn: "حل",
      clearBtn: "إغلاق",
      reopenBtn: "إعادة فتح",
      inProgressBtn: "قيد التنفيذ",
      markedInProgress: "تم التمييز كقيد التنفيذ",
      markedResolved: "تم التمييز كمحلولة",
      cleared: "تم الإغلاق",
      reopened: "تمت إعادة الفتح",
      priorityPrefix: "الأولوية: {p}",
      deletedTag: "محذوف",
      raisedByLine: "أُثيرت بواسطة {name} ({role}) · {date}",
      dueSuffix: " · تستحق {date}",
      commentPh: "أضف تعليقاً…",
      postComment: "نشر التعليق",
      commentAdded: "تمت إضافة التعليق",
      commentFailed: "فشل التعليق",
      enterComment: "أدخل تعليقاً",
      loadHistoryFailed: "فشل تحميل السجل",
      deleteConfirm: "حذف نقطة المراجعة؟ سيتم حذفها مع الاحتفاظ بها في السجل.",
      deleted: "تم الحذف",
      deleteFailed: "فشل الحذف",
      commentsLabel: "التعليقات",
      timelineLabel: "الخط الزمني",
      attachmentsLabel: "المرفقات",
      commentByLine: "({role} · {when})",
      badgeSummary: "{plural} — {open} مفتوحة، {cleared} مغلقة",
    },
    reviewForms: {
      acceptanceNoticeEN: "Review engagement — the engagement letter and acceptance form below use limited-assurance wording (ISRE 2400 Revised). This is a review, not an audit.",
      acceptanceNoticeAR: "ارتباط فحص — تستخدم رسالة الارتباط ونموذج القبول أدناه صياغة التأكيد المحدود (\u2066ISRE 2400\u2069 المُنقّح). هذا فحص، وليس مراجعة.",
      elReviewTitleEN: "Engagement letter — review (limited assurance)",
      elReviewTitleAR: "رسالة الارتباط — فحص (تأكيد محدود)",
      elReviewBodyEN: "We will conduct our engagement to review the accompanying financial statements in accordance with ISRE 2400 (Revised). Our conclusion will express whether anything has come to our attention that causes us to believe that the financial statements are not prepared, in all material respects, in accordance with the applicable financial-reporting framework. A review differs significantly from an audit; we will not express an audit opinion.",
      elReviewBodyAR: "سنؤدي ارتباطنا لفحص القوائم المالية المرفقة وفقًا للمعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح). ستعبِّر خلاصتنا عمّا إذا كان قد ورد إلى علمنا ما يجعلنا نعتقد أن القوائم المالية لم تُعَدّ من جميع النواحي الجوهرية وفقًا لإطار التقرير المالي المطبَّق. يختلف الفحص اختلافًا جوهريًا عن المراجعة؛ ولن نُبدي رأيًا في المراجعة.",
      cacReviewTitleEN: "Client acceptance / continuance — review",
      cacReviewTitleAR: "قبول العميل / استمراره — فحص",
      cacReviewBodyEN: "This acceptance record captures the preconditions for a review engagement under ISRE 2400 (Revised): rational purpose, an acceptable financial-reporting framework, management's acknowledgement of its responsibilities, ethics and independence, availability of information and no management-imposed scope limitation. Wording used throughout is limited-assurance.",
      cacReviewBodyAR: "يوثِّق هذا السجل الشروط المسبقة لارتباط الفحص وفق \u2066ISRE 2400\u2069 (المُنقّح): الغرض المنطقي، وإطار التقرير المالي المقبول، وإقرار الإدارة بمسؤولياتها، والسلوك المهني والاستقلالية، وإتاحة المعلومات، وعدم وجود قيد على النطاق مفروض من الإدارة. الصياغة المستخدمة تعبِّر عن التأكيد المحدود.",
      elSubtitleEN: "Based on ISRE 2400 (Revised) — Agreeing the terms of a review engagement",
      elSubtitleAR: "استنادًا إلى المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — الاتفاق على شروط ارتباط الفحص",
      cacSubtitleEN: "Based on ISRE 2400 (Revised) — Agreeing the terms of a review engagement",
      cacSubtitleAR: "استنادًا إلى المعيار الدولي لارتباطات الفحص \u2066ISRE 2400\u2069 (المُنقّح) — الاتفاق على شروط ارتباط الفحص",
      sectionGreyEN: "Not used in a review — preconditions are in \u2066501(r)\u2069",
      sectionGreyAR: "غير مستخدم في ارتباط الفحص — الشروط المسبقة في \u2066501(r)\u2069",
      sectionEnableTitleEN: "Enable this section for this engagement",
      sectionEnableTitleAR: "تفعيل هذا القسم لهذه المهمة",
      sectionEnableHintEN: "Any engagement-team auditor may enable this section for a documented review matter (additional or alternative procedure). The change is logged.",
      sectionEnableHintAR: "يجوز لأي عضو من فريق المهمة تفعيل هذا القسم لموضوع فحص موثَّق (إجراء إضافي أو بديل). يُسجَّل التغيير.",
      sectionEnableBtnEN: "Enable this section",
      sectionEnableBtnAR: "تفعيل هذا القسم",
      sectionEnabledOkEN: "Section enabled for this engagement.",
      sectionEnabledOkAR: "تم تفعيل القسم لهذه المهمة.",
    },
    // K6 — spec labels (AR) verbatim.
    reviewSpec: {
      materialItem: "بند جوهري",
      inquiry: "الاستفسار",
      analyticalProcedure: "إجراء تحليلي",
      conclusion: "الاستنتاج",
      conclusionSatisfactory: "مُرْضٍ",
      conclusionFollowup: "متابعة \u2190 \u2066W17.7\u2069",
      requiredInquiries: "الاستفسارات المطلوبة",
      fraudOrNoncomplianceIndicators: "مؤشرات الغش أو عدم الالتزام",
      reconciliationToAccountingRecords: "المطابقة مع السجلات المحاسبية",
      additionalProcedures: "إجراءات إضافية",
      outcome: "النتيجة",
      areasLikelyMisstatement: "المجالات التي يُرجَّح فيها وجود تحريفات جوهرية",
    },
  },
};

export default I18N_BASE_REVIEW_POINTS;
